export const serialize = values => ({
  ...values,
  sensor_ids: values.sensor_ids || [],
  metadata: {
    tags: values.tags
  }
})
